import {Component, OnDestroy, OnInit} from "@angular/core";
import {Subscription} from "rxjs";
import {StatistiquesEGAlimService} from "../../../core/services/egalim/statistiques-egalim.service";
import {UtilsService} from "../../../core/utils/utils.service";
import {InternationalizationService} from "../../../core/services/i8n/i8n.service";

@Component({
    selector: 'yo-statistiques-egalim-error-dialog',
    templateUrl: './statistiques-egalim-error-dialog.component.html',
    styleUrls: ['./statistiques-egalim-error-dialog.component.scss'],
    standalone: false
})
export class StatistiquesEgalimErrorDialogComponent implements OnInit, OnDestroy {

  public displayed: boolean = false;

  private subOpen: Subscription;

  public errors: StatError[];

  constructor(
    private utilsSvc: UtilsService,
    private statistiquesEgalimSvc: StatistiquesEGAlimService,
    private i8nSvc: InternationalizationService) {
  }

  ngOnInit(): void {
    this.initSubOpen();
  }

  ngOnDestroy() {
    this.utilsSvc.unsubscribe(this.subOpen);
  }

  initSubOpen = () => {
    this.subOpen = this.statistiquesEgalimSvc.openErrorDialog$.subscribe((responseErrors) => {
      this.errors = [];

      responseErrors.forEach(error => {
        const stat = error.entity;
        const displayError = error.values.map(e => this.i8nSvc.getLabelFromCode(e.code, e.args.split(','))).join("\r\n");

        this.errors.push({
          id: this.errors.length + 1,
          pointTeledeclarationLibelle: stat.pointTeledeclaration.libelle,
          siret: stat.pointTeledeclaration.siret,
          annee: stat.annee,
          error: displayError
        });
      });

      this.displayed = true;
    })
  }
}

class StatError {
  id: number;
  pointTeledeclarationLibelle: string;
  siret: string;
  annee: Date;
  error: string;
}
